module.exports = __webpack_public_path__ + "clickup-logo-893419b9e6aa077e1085f190e13a6577.png";